module.exports = __webpack_public_path__ + "static/img/testimony (85).f931db51.jpg";